const Lottie = ({ animationData, ...props }: any) => (
  <lottie-player
    background="transparent"
    src={animationData}
    {...props}
  ></lottie-player>
);

export default Lottie;
